const NavLeakedPasswordIcon = () => {
    return (
        <svg width={16} height={17}
            viewBox="0 0 16 17" fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask id="mask0_24_13397"
                style={{ maskType: "alpha" }}
                maskUnits="userSpaceOnUse"
                x={0} y={0} width={16} height={17}
            >
                <path fillRule="evenodd" clipRule="evenodd" fill="black"
                    d="M0 8.5C0 6.29086 1.79086 4.5 4 4.5C5.48128 4.5 6.77364 5.30519 7.46476 6.5H14C14.1326 6.5 14.2598 6.55268 14.3536 6.64645L15.8536 8.14645C16.0488 8.34171 16.0488 8.65829 15.8536 8.85355L14.3536 10.3536C14.1583 10.5488 13.8417 10.5488 13.6464 10.3536L13 9.70711L12.3536 10.3536C12.1583 10.5488 11.8417 10.5488 11.6464 10.3536L11 9.70711L10.3536 10.3536C10.1583 10.5488 9.84171 10.5488 9.64645 10.3536L9 9.70711L8.35355 10.3536C8.25979 10.4473 8.13261 10.5 8 10.5H7.46476C6.77364 11.6948 5.48128 12.5 4 12.5C1.79086 12.5 0 10.7091 0 8.5ZM4 5.5C2.34315 5.5 1 6.84315 1 8.5C1 10.1569 2.34315 11.5 4 11.5C5.19599 11.5 6.22952 10.8002 6.71155 9.78545C6.79438 9.6111 6.97016 9.5 7.16318 9.5H7.79289L8.64645 8.64645C8.84171 8.45118 9.15829 8.45118 9.35355 8.64645L10 9.29289L10.6464 8.64645C10.8417 8.45118 11.1583 8.45118 11.3536 8.64645L12 9.29289L12.6464 8.64645C12.8417 8.45118 13.1583 8.45118 13.3536 8.64645L14 9.29289L14.7929 8.5L13.7929 7.5H7.16318C6.97016 7.5 6.79438 7.3889 6.71155 7.21455C6.22952 6.19984 5.19599 5.5 4 5.5Z"
                />
                <path fill="black"
                    d="M4 8.5C4 9.05228 3.55228 9.5 3 9.5C2.44772 9.5 2 9.05228 2 8.5C2 7.94772 2.44772 7.5 3 7.5C3.55228 7.5 4 7.94772 4 8.5Z"
                />
            </mask>
            <g mask="url(#mask0_24_13397)">
                <rect y="0.5" width={16} height={16} fill="#A0AEC0" />
            </g>
        </svg>
    );
}

export default NavLeakedPasswordIcon;